import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import cn from 'classnames';

import { INewSupplementInitialControlsProps } from './NewSupplementInitialControls.interface';

import './style.scss';

const NewSupplementInitialControls: FC<INewSupplementInitialControlsProps> = ({
  className,
  onMatchExisting,
  onMarkAsMedication,
  onNeedMoreInfo,
  submitFormId,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn('new-supplement-initial-controls', className)}>
      <Button
        className="new-supplement-initial-controls__match-existing"
        variant="outlined"
        onClick={onMatchExisting}
      >
        {t('adminNewSupplement.matchExisting')}
      </Button>

      <Button
        className="new-supplement-initial-controls__need-more-info"
        variant="outlined"
        onClick={onNeedMoreInfo}
      >
        {t('adminNewSupplement.needMoreInfo')}
      </Button>

      <Button
        className="new-supplement-initial-controls__mark-as-medication"
        variant="outlined"
        onClick={onMarkAsMedication}
      >
        {t('adminNewSupplement.medication')}
      </Button>

      <Button
        className="new-supplement-initial-controls__submit"
        type="submit"
        variant="contained"
        form={submitFormId}
      >
        {t('adminNewSupplement.createNew')}
      </Button>
    </div>
  );
};

export default NewSupplementInitialControls;
